<template>
  <div id="contenedor-estadisiticas-expediente">
    <v-row justify="space-between" align="center">
      <!-- Buscar -->
      <v-col cols="auto">
        <div style="width: 350px" class="mx-2 my-6">
          <custom-text-field
            label="Buscar..."
            append-icon="mdi-magnify"
            clearable
            @keyup="buscar"
            @click:clear="limpiarBuscadorTexto">
          </custom-text-field>
        </div>
      </v-col>
      <!-- Datos Estadisticos del Expediente -->
      <v-col cols="auto">
        <v-row md="3">
          <v-col class="px-2">
            <v-card
              flat
              color="blue darken-1"
              dark
              width="140"
              height="100">
              <v-card-text class="text-center white--text pb-1">
                <h1>{{datosEstadisticos.documentosTotales}}</h1>
              </v-card-text>
              <v-card-text class="text-center white--text pt-1">
                <h3>Documentos Totales</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="px-2">
            <v-card
              dark
              flat
              color="warning"
              width="140"
              height="100">
              <v-card-text class="text-center white--text pb-1 pt-6">
                <h1>{{datosEstadisticos.documentosAplican}}</h1>
              </v-card-text>
              <v-card-text class="text-center white--text pt-1">
                <h3>Aplican</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="px-2">
            <v-card
              flat
              color="success"
              dark
              width="140"
              height="100">
              <v-card-text class="text-center white--text pb-1 pt-6">
                <h1>{{datosEstadisticos.documentosIntegrados}}</h1>
              </v-card-text>
              <v-card-text class="text-center white--text pt-1">
                <h3>Integrados</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="px-2">
            <v-card
              flat
              :color="datosEstadisticos.documentosFaltantes === 0 ? 'success' : 'red darken-1'"
              dark
              width="140"
              height="100">
              <v-card-text class="text-center white--text pb-1 pt-6">
                <h1>{{datosEstadisticos.documentosFaltantes}}</h1>
              </v-card-text>
              <v-card-text class="text-center white--text pt-1">
                <h3>Faltantes</h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'EstadisiticasExpediente',
  props: {
    datosEstadisticos: {
      type: Object,
      required: false,
    },
  },
  components: {
    CustomTextField,
  },
  data() {
    return {
      buscarTexto: null,
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
  },
  watch: {
    buscarTexto: {
      handler() {
        this.$emit('buscar', this.buscarTexto);
      },
    },
  },
};
</script>

<style>

</style>
